import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Alert,
} from "@mui/material";
import { AppPasswordField } from "components/common/inputs";
import { resetUserPassword } from "../../services/user.service";
import { validatePassword } from "utils/passwordPolicy";
import "./UserModals.css";
import { AppButton } from "components/common/buttons";

const ChangePasswordModal = ({ open, onClose, user }) => {
  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    // Clear error for this field
    if (formErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: null,
      });
    }
  };
  const validateForm = () => {
    const errors = {};

    const passwordError = validatePassword(formData.newPassword);
    if (passwordError) {
      errors.newPassword = passwordError;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      errors.confirmPassword = "Mật khẩu xác nhận không khớp";
    }

    return errors;
  };
  const handleSubmit = async () => {
    // Validate form
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    if (!user) return;

    setIsSubmitting(true);
    setError(null);
    try {
      // Use resetUserPassword - Admin only operation
      await resetUserPassword(user.userId, formData.newPassword);

      setSuccess(true);

      // Reset form after successful submission
      setTimeout(() => {
        setFormData({
          newPassword: "",
          confirmPassword: "",
        });
        setSuccess(false);
        onClose();
      }, 1500);
    } catch (err) {
      console.error("Error resetting password:", err);
      if (err.response && err.response.data) {
        setError(
          err.response.data.message || "Có lỗi xảy ra khi đặt lại mật khẩu."
        );
      } else {
        setError("Có lỗi xảy ra khi đặt lại mật khẩu. Vui lòng thử lại sau.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleClose = () => {
    // Reset form and errors on close
    setFormData({
      newPassword: "",
      confirmPassword: "",
    });
    setFormErrors({});
    setError(null);
    setSuccess(false);
    onClose();
  };

  if (!user) return null;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle fontWeight={600}>
        Đặt lại mật khẩu cho người dùng: {user.userName}
      </DialogTitle>{" "}
      <DialogContent>
        {error && (
          <Alert severity="error" className="alert-margin">
            {error}
          </Alert>
        )}

        {success && (
          <Alert severity="success" className="alert-margin">
            Đặt lại mật khẩu thành công!
          </Alert>
        )}

        <div className="form-row">
          <AppPasswordField
            name="newPassword"
            label="Mật khẩu mới *"
            value={formData.newPassword}
            onChange={(_, event) => handleChange(event)}
            fullWidth
            size="medium"
            error={!!formErrors.newPassword}
            helperText={formErrors.newPassword}
            disabled={isSubmitting || success}
            margin="normal"
          />
        </div>

        <div className="form-row">
          <AppPasswordField
            name="confirmPassword"
            label="Xác nhận mật khẩu mới *"
            value={formData.confirmPassword}
            onChange={(_, event) => handleChange(event)}
            fullWidth
            size="medium"
            error={!!formErrors.confirmPassword}
            helperText={formErrors.confirmPassword}
            disabled={isSubmitting || success}
            margin="normal"
          />
        </div>
      </DialogContent>
      <DialogActions>
        <AppButton variant="outlined" onClick={handleClose} disabled={isSubmitting}>
          Hủy
        </AppButton>
        <AppButton
          onClick={handleSubmit}
          variant="contained"
          disabled={isSubmitting || success}
          disableElevation
        >
          {isSubmitting ? <CircularProgress size={24} /> : "Đặt lại mật khẩu"}
        </AppButton>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePasswordModal;
